import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  @Input() onShowSection;
  @Input() onShowPeriod;
  @Input() onShowMenu;
  period: String = 'today';

  @Output() periodUpdated = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onTogglePeriod() {
    this.periodUpdated.emit(this.period);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/navbar/navbar.component.ts